// Product listing page accessibility enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Handle product cards keyboard navigation
  const productCards = document.querySelectorAll('.productcard');
  
  const ratingElements = document.querySelectorAll('.ruk_rating_snippet');
  ratingElements.forEach(element => {
    // Add tabindex=-1 to the rating element itself
    element.setAttribute('tabindex', '-1');
    element.setAttribute('aria-hidden', 'true');
    
    // Remove all interactive elements from tab order
    const interactiveElements = element.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    interactiveElements.forEach(el => {
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-hidden', 'true');
    });
  });
  
  const focusableElements = [];
  productCards.forEach((card, index) => {
    const productLink = card.querySelector('a.product-link');
    const addToCartButton = card.querySelector('.add-to-cart-button');
    
    if (productLink) focusableElements.push({ element: productLink, cardIndex: index });
    if (addToCartButton) focusableElements.push({ element: addToCartButton, cardIndex: index });
    
    const allOtherFocusableElements = card.querySelectorAll('a:not(.product-link), button:not(.add-to-cart-button), [tabindex]:not([tabindex="-1"])');
    allOtherFocusableElements.forEach(el => {
      if (el !== productLink && el !== addToCartButton) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  });
  
  // Process each product card for keyboard navigation
  productCards.forEach((card, cardIndex) => {
    const productLink = card.querySelector('a.product-link');
    const addToCartButton = card.querySelector('.add-to-cart-button');
    
    // Skip if elements not found
    if (!productLink) return;
    
    // When product link gets focus, show the card is focused
    productLink.addEventListener('focus', function() {
      card.classList.add('card-focus');
      

      if (addToCartButton) {
        addToCartButton.style.display = 'block';
        addToCartButton.style.opacity = '1';
        addToCartButton.style.zIndex = '50';
      }
    });
    
    productLink.addEventListener('blur', function() {

      card.classList.remove('card-focus');
    });
    
    // Handle keyboard navigation on product link
    productLink.addEventListener('keydown', function(e) {
      // If user presses Enter or Space, follow the link
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.location.href = this.getAttribute('href');
      }
      
      if (e.key === 'Tab' && !e.shiftKey && addToCartButton) {
        e.preventDefault(); // Prevent default tab behavior
        
        // Make Add to Cart button visible
        addToCartButton.style.display = 'block';
        addToCartButton.style.opacity = '1';
        addToCartButton.style.zIndex = '50';
        
        setTimeout(() => {
          addToCartButton.focus();
        }, 10);
      }
    });
    

    if (addToCartButton) {
      addToCartButton.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          
          // Find the next product card's product link
          const nextCardIndex = cardIndex + 1;
          if (nextCardIndex < productCards.length) {
            const nextCard = productCards[nextCardIndex];
            const nextProductLink = nextCard.querySelector('a.product-link');
            if (nextProductLink) {
              setTimeout(() => {
                nextProductLink.focus();
              }, 10);
            }
          }
        }
        
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          setTimeout(() => {
            productLink.focus();
          }, 10);
        }
      });
    }
    
    // When focus leaves the card, hide the Add to Cart button again
    card.addEventListener('focusout', function(e) {
      // Only hide if focus is leaving this card completely
      if (!card.contains(e.relatedTarget) && addToCartButton) {
        // Check if screen is desktop
        if (window.innerWidth >= 1024) {
          addToCartButton.style.display = '';
        }
        
        card.classList.remove('card-focus');
      }
    });
  });
  

  const style = document.createElement('style');
  style.textContent = `
    .card-focus {
      outline: 3px solid #5F9353 !important;
      outline-offset: 4px !important;
      border-radius: 8px;
    }
  `;
  document.head.appendChild(style);
  
  // Handle dynamically loaded rating elements
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { 
            const newRatings = node.querySelectorAll ? node.querySelectorAll('.ruk_rating_snippet') : [];
            if (node.classList && node.classList.contains('ruk_rating_snippet')) {
              newRatings.push(node);
            }
            
            newRatings.forEach(element => {
              element.setAttribute('tabindex', '-1');
              element.setAttribute('aria-hidden', 'true');
              
              const interactiveElements = element.querySelectorAll('a, button, input, select, textarea, [tabindex]');
              interactiveElements.forEach(el => {
                el.setAttribute('tabindex', '-1');
                el.setAttribute('aria-hidden', 'true');
              });
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}); 